import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';


interface DocumentItem {
  id: number | string;
  name: string;
  type?: string;
  previewUrl?: string;
}

import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  NgZone,
  OnDestroy,
  ViewChild
} from '@angular/core';

import {
  Room,
  RoomEvent,
  LocalAudioTrack,
  Track,
  RemoteAudioTrack,
  RemoteParticipant,
  ConnectionState,
  TranscriptionSegment,
  LocalTrackPublication,
  Participant,
  RemoteTrack,
  RemoteTrackPublication,
  createLocalAudioTrack
} from 'livekit-client';
import { AskQuestionService } from '../ask-question.service';
import { firstValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenResponse } from 'app/talk-ai-agent/talk-ai-agent.component';
import { AgentServiceService } from 'app/talk-ai-agent/agent-service.service';
import { config } from 'app/app.config';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

export interface Transcript {
  id: string;
  text: string;
  isAgent: boolean;
  final: boolean;
  language?: string;
  startTime?: number;
  endTime?: number;
}

export interface LiveKitTokenResponse {
  roomName: string;
  token: string;
  url: string;
}

@Component({
  selector: 'app-voice-agent',
  imports: [CommonModule, TooltipModule, FormsModule, NgxDocViewerModule],
  templateUrl: './voice-agent.component.html',
  styleUrl: './voice-agent.component.scss'
})
export class VoiceAgentComponent implements OnDestroy {


  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @HostBinding('style.flex-direction') direction = 'column';

  @ViewChild('transcriptContainer')
  transcriptContainer!: ElementRef<HTMLDivElement>;

  room: Room | null = null;

  localAudioTrack?: LocalAudioTrack;

  readonly transcriptMap = new Map<string, Transcript>();
  transcripts: Transcript[] = [];

  connected = false;
  connecting = false;
  muted = false;

  connectLabel = 'Connect';

  statusText = 'Ready';

  statusState: 'default' | 'connecting' | 'connected' = 'default';

  toastMessage = '';

  typedMessage = '';

  agentSpeaking = false;

  userSpeaking = false;

  showAvatar = false;

  manualMuted = false;

  manualAudioMuted = false;

  avatarImage = 'assets/images/ai_avatar/ai_female_avatar_img.png';

  readonly femaleIdleAvatar = 'assets/images/ai_avatar/ai_female_avatar_img.png';
  readonly femaleTalkingAvatar = 'assets/images/ai_avatar/ai_female_avatar.gif';

  readonly maleIdleAvatar = 'assets/images/ai_avatar/ai_male_avatar_img.png';
  readonly maleTalkingAvatar = 'assets/images/ai_avatar/ai_male_avatar.gif';


  participant?: RemoteParticipant;

  private audioElements: HTMLAudioElement[] = [];


  private muteInProgress = false;

  stateCode: any = "";


  showDocumentDropdown = false;

  documentSearch = '';

  selectedDocument: any[] | null = null;

  currentDocumentIndex = 0;

  // selectDocument:any[] = [];

  selectedDoc_ids: any[] = [];


  documents: any[] = [];
  // documents: DocumentItem[] = [
  //   {
  //     id: 1,
  //     name: 'Employee Handbook.pdf',
  //     type: 'PDF',
  //     previewUrl: 'assets/documents/employee-handbook.pdf'
  //   },
  //   {
  //     id: 2,
  //     name: 'Leave Policy.pdf',
  //     type: 'PDF',
  //     previewUrl: 'assets/documents/leave-policy.pdf'
  //   },
  //   {
  //     id: 3,
  //     name: 'Company Policy.pdf',
  //     type: 'PDF',
  //     previewUrl: 'assets/documents/company-policy.pdf'
  //   }
  // ];

  selectedAllStateCode: any;


  private micTimer: ReturnType<typeof setTimeout> | null = null;
  private micOperation = false;

  offset = config.DEFAULT_OFFSET;
  limit = config.DEFAULT_RECORD_LIMIT;

  search:string = '';

  // filteredDocuments: any[] = [];


  provider: any[] = [
    {
      id: 1,
      name: 'Canstring Voice',
      provider: 'omnivoice'
    },
    {
      id: 2,
      name: 'ElevenLabs',
      provider: 'elevenlabs'
    }
  ];

  elevenVoice: any[] = [
    { id: "EXAVITQu4vr4xnSDxMaL", name: "Sarah", gender: 'female' },
    { id: "cgSgspJ2msm6clMCkdW9", name: "Jessica", gender: 'female' },
    { id: "JBFqnCBsd6RMkjVDRZzb", name: "George", gender: 'male' },
    { id: "Xb7hH8MSUJpSbSDYk0k2", name: "Alice", gender: 'female' },
    { id: "hpp4J3VqNfWAUOO0d1Us", name: "Bella", gender: 'female' },
    { id: "CwhRBWXzGAHq8TQ4Fs17", name: "Roger", gender: 'male' },
    { id: "FGY2WhTYpPnrIDTdsKH5", name: "Laura", gender: 'male' },
    { id: "IKne3meq5aSn9XLyUdCD", name: "Charlie", gender: 'male' },
    { id: "N2lVS1w4EtoT3dr4eOWO", name: "Callum", gender: 'male' },
    { id: "SAz9YHcvj6GT2YYXdXww", name: "River", gender: 'male' },
    { id: "yK2Ny0mq8WplixhD1td3", name: "Caroline Braden", gender: 'female' }
  ];

  canstringVoice: any[] = [
    { id: "viraj", name: "viraj-us-m", gender: 'male' },
    { id: "anna", name: "anna-us-f", gender: 'female' },
    { id: "lexi", name: "lexi-us-f", gender: 'female' },
    { id: "max", name: "max-us-m", gender: 'male' },
    { id: "ram_ka", name: "ram_ka", gender: 'male' },
    { id: "ram_ml", name: "ram_ml", gender: 'male' }
  ];

  // Selected values
  selectedProvider: any = null;
  selectedVoice: any = null;
  voiceList: any[] = [];

  agentIsSpeaking = false;

  constructor(
    private readonly botService: AskQuestionService,
    private readonly zone: NgZone,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly agentService: AgentServiceService,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {

      const state = params.get('state') || '';

      if (state === 'all') {
        this.stateCode = '';
      } else {
        this.stateCode =  params.get('state') || '';
      }
    });


    const company_id = localStorage.getItem('company_id');

    const user_id = localStorage.getItem('user_id');

    const payload = {

      offset: this.offset,

      limit: 1000,

      search: this.search ?? '',

      company_id,

      user_id,

      is_doc_section: true

    };


    const stateCode = this.stateCode;

    this.botService.getMessageAttachments(payload).subscribe({
      next: (res: any) => {
        const documents = res?.recordList ?? [];

        const code = stateCode?.trim().toLowerCase();
        // const name = stateName?.trim().toLowerCase();

        if (this.stateCode === '') {
          this.selectedAllStateCode = [...new Set(
            documents
              .map((x: any) => x.policy_state)
              .filter((state: any) => state)
          )];
        }


        if (code != '') {
          this.documents = documents.filter((doc: any) => {
            const message = doc?.policy_state?.trim().toLowerCase();

            return (
              (code && message?.includes(code)));
          });

          // this.filteredDocuments = [...this.documents];
        } else {
          this.documents = documents;

          // this.filteredDocuments = [...this.documents];
        }



        this.selectedDoc_ids = this.documents.map(
          (item: any) => item.llmfile_uuid
        );

        // console.log(
        //   'Matched documents:',
        //   this.electedDocuments
        // );

        // console.log(
        //   'Selected IDs:',
        //   this.selectedDoc_ids
        // );
      },

      error: (err: any) => {
        console.error('Failed to load documents:', err);
        this.documents = [];
        this.selectedDoc_ids = [];
      }
    });
  }

  private generateId(): string {
    return Date.now().toString() + Math.random().toString(36).substring(2);
  }

  toggleSession(): void {
    if (this.connecting) {
      return;
    }

    if (this.connected) {
      this.disconnect();
    } else {
      this.connect();
    }
  }

  onProviderChange(provider: any): void {

    console.log('Provider changed:', provider);

    if (this.connected || this.connecting) {
      return;
    }

    this.selectedProvider = provider;

    this.selectedVoice = null;
    this.voiceList = [];

    this.agentSpeaking = false;

    if (!provider) {
      this.avatarImage = this.femaleIdleAvatar;
      this.cdr.detectChanges();
      return;
    }

    switch (provider) {

      case 'omnivoice':
        this.voiceList = [...this.canstringVoice];
        break;

      case 'elevenlabs':
        this.voiceList = [...this.elevenVoice];
        break;

      default:
        this.voiceList = [];
        break;
    }

    console.log('Selected Provider:', this.selectedProvider);
    console.log('Voice List:', this.voiceList);

    this.avatarImage = this.femaleIdleAvatar;

    this.cdr.detectChanges();
  }

  private updateAvatar(): void {
    const gender = this.selectedVoice?.gender;

    if (gender === 'male') {
      this.avatarImage = this.agentSpeaking
        ? this.maleTalkingAvatar
        : this.maleIdleAvatar;
    } else {
      // Default to female
      this.avatarImage = this.agentSpeaking
        ? this.femaleTalkingAvatar
        : this.femaleIdleAvatar;
    }

    this.cdr.detectChanges();
  }


  async connect(): Promise<void> {

    if (this.room?.state === ConnectionState.Connected) {
      console.log('Already connected.');
      return;
    }

    if (this.connecting) {
      return;
    }

    this.connecting = true;
    this.connected = false;
    this.manualMuted = false;
    this.muted = false;

    this.connectLabel = 'Connecting...';
    this.statusText = 'Connecting...';
    this.statusState = 'connecting';
    // this.avatarImage = this.idleAvatar;

    this.cdr.detectChanges();

    try {

      // Get LiveKit credentials
      const { token, url } = await this.fetchToken();

      if (!token || !url) {
        throw new Error('Invalid LiveKit response.');
      }

      // console.log('Room Name:', roomName);
      console.log('URL:', url);

      // Clean previous room
      if (this.room) {
        this.room.removeAllListeners();
        await this.room.disconnect();
        this.room = null;
      }

      // Clear previous state
      this.audioElements.forEach(audio => {
        audio.pause();
        audio.remove();
      });

      this.audioElements = [];
      // this.transcriptMap.clear();
      // this.transcripts = [];

      // Create Room
      this.room = new Room({
        audioCaptureDefaults: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
        adaptiveStream: true,
        dynacast: true
      });

      // Register listeners
      this.registerRoomEvents();

      // Connect
      await this.room.connect(url, token);

      console.log('Connected Room:', this.room.name);
      console.log(
        'Local Identity:',
        this.room.localParticipant.identity
      );

      // Enable microphone
      await this.room.localParticipant.setMicrophoneEnabled(true);

      // Wait briefly until publication is available
      await new Promise(resolve => setTimeout(resolve, 100));

      const publication =
        this.room.localParticipant.getTrackPublication(
          Track.Source.Microphone
        ) as LocalTrackPublication | undefined;

      if (publication?.track) {
        this.localAudioTrack = publication.track as LocalAudioTrack;
      } else {
        console.warn('Microphone publication not found.');
      }

      this.connected = true;
      this.connecting = false;
      this.muted = false;

      this.connectLabel = 'Disconnect';
      // this.statusText = `Connected - ${roomName}`;
      this.statusState = 'connected';

      // this.avatarImage = this.idleAvatar;

      this.cdr.detectChanges();

    } catch (error) {

      console.error('LiveKit Connection Error:', error);

      this.connected = false;
      this.connecting = false;
      this.manualMuted = false;
      this.muted = false;

      this.connectLabel = 'Connect';
      this.statusText = 'Connection Failed';
      this.statusState = 'default';
      // this.avatarImage = this.idleAvatar;

      if (this.room) {
        this.room.removeAllListeners();
        await this.room.disconnect();
        this.room = null;
      }

      this.localAudioTrack = undefined;
      this.audioElements = [];

      this.cdr.detectChanges();
    }
  }

  // async fetchToken(): Promise<any> {

  //   const payload = {
  //     customer_name: 'visitor'
  //   };

  //   return firstValueFrom(
  //     this.botService.aiAgentVoiceConnect(payload)
  //   );

  // }


  async fetchToken(): Promise<TokenResponse> {

    if (!this.selectedProvider) {
      throw new Error('Please select a voice provider.');
    }

    if (!this.selectedVoice) {
      throw new Error('Please select a voice.');
    }

    const body = {

      agentId: `fabea43b-a970-4dae-a051-4522f0955087`,

      tts_provider:
        this.selectedProvider,

      tts_speaker:
        this.selectedVoice.id,

      tts_model:
        this.selectedProvider === 'elevenlabs'
          ? 'eleven_turbo_v2_5'
          : 'omnivoice',

      customer_name: 'Visitor'
    };

    try {

      const response: any =
        await firstValueFrom(
          this.agentService.selectAIAgent(body)
        );

      if (
        !response?.token ||
        !response?.url
      ) {
        throw new Error(
          'Invalid token response.'
        );
      }

      return response as TokenResponse;

    } catch (error) {

      console.error(
        'Fetch Token Error:',
        error
      );

      throw error instanceof Error
        ? error
        : new Error(
          'Unable to fetch connection token.'
        );
    }
  }


  private registerRoomEvents(): void {

    if (!this.room) {
      return;
    }

    // Remove previously registered listeners
    this.room.removeAllListeners();

    this.room.on(RoomEvent.Connected, this.onConnected.bind(this));
    this.room.on(
      RoomEvent.TrackSubscribed,
      this.onTrackSubscribed.bind(this)
    );
    this.room.on(
      RoomEvent.TrackUnsubscribed,
      this.onTrackUnsubscribed.bind(this)
    );
    this.room.on(
      RoomEvent.ActiveSpeakersChanged,
      this.onActiveSpeakersChanged.bind(this)
    );
    this.room.on(
      RoomEvent.TranscriptionReceived,
      this.onTranscriptionReceived.bind(this)
    );
    this.room.on(
      RoomEvent.Disconnected,
      this.onDisconnected.bind(this)
    );
  }

  private onConnected(): void {

    console.log('Room Connected');

    this.connected = true;
    this.connecting = false;
    this.agentSpeaking = false;
    this.manualMuted = false;
    this.muted = false;

    // this.avatarImage = this.idleAvatar;

    this.agentSpeaking = false;
    this.updateAvatar();

    console.log(
      'Remote Participants:',
      this.room?.remoteParticipants.size
    );

    this.cdr.detectChanges();
  }

  private onTrackSubscribed(
    track: RemoteTrack,
    publication: RemoteTrackPublication,
    participant: RemoteParticipant
  ): void {

    if (track.kind !== Track.Kind.Audio) {
      return;
    }

    const remoteTrack = track as RemoteAudioTrack;

    const exists = this.audioElements.some(
      audio => audio.dataset.trackSid === remoteTrack.sid
    );

    if (exists) {
      return;
    }

    const audio = remoteTrack.attach() as HTMLAudioElement;

    audio.autoplay = true;
    audio.dataset.trackSid = remoteTrack.sid;

    document.body.appendChild(audio);
    this.audioElements.push(audio);

    audio.play().catch(err => {
      console.warn('Autoplay blocked:', err);
    });
  }

  private onTrackUnsubscribed(track: RemoteTrack): void {

    if (track.kind !== Track.Kind.Audio) {
      return;
    }

    track.detach().forEach((element: any) => {

      element.pause?.();
      element.srcObject = null;
      element.remove();

      this.audioElements = this.audioElements.filter(
        audio => audio !== element
      );
    });
  }

  // private async onActiveSpeakersChanged(
  //   speakers: Participant[]
  // ): Promise<void> {

  //   if (!this.room) {
  //     return;
  //   }

  //   const localId = this.room.localParticipant.identity;

  //   const agentSpeaking = speakers.some(
  //     speaker => speaker.identity !== localId
  //   );

  //   if (this.agentSpeaking === agentSpeaking) {
  //     return;
  //   }

  //   this.agentSpeaking = agentSpeaking;

  //   if (this.micTimer) {
  //     clearTimeout(this.micTimer);
  //     this.micTimer = null;
  //   }


  //   // this.avatarImage = agentSpeaking
  //   //   ? this.talkingAvatar
  //   //   : this.idleAvatar;

  //   this.cdr.markForCheck();
  // }


  private async onActiveSpeakersChanged(
    speakers: Participant[]
  ): Promise<void> {

    if (!this.room) {
      return;
    }

    const localId = this.room.localParticipant.identity;

    const agentSpeaking = speakers.some(
      speaker => speaker.identity !== localId
    );

    if (this.agentSpeaking === agentSpeaking) {
      return;
    }

    this.agentSpeaking = agentSpeaking;

    if (this.micTimer) {
      clearTimeout(this.micTimer);
      this.micTimer = null;
    }

    // Switch PNG <-> GIF based on selected voice gender
    this.updateAvatar();

    this.cdr.markForCheck();
  }

  onVoiceChange(voice: any): void {

    if (this.connected || this.connecting) {
      return;
    }

    this.selectedVoice = voice;

    // Reset speaking state when changing voice
    this.agentSpeaking = false;

    this.updateAvatar();

    console.log('Selected Voice:', this.selectedVoice);
    console.log('Voice Gender:', this.selectedVoice?.gender);
  }

  private onTranscriptionReceived(
    segments: TranscriptionSegment[],
    participant?: Participant
  ): void {

    if (
      this.agentSpeaking &&
      participant?.identity === this.room?.localParticipant.identity
    ) {
      return;
    }

    const isAgent =
      participant?.identity !==
      this.room?.localParticipant.identity;

    for (const segment of segments) {

      if (!segment.text?.trim()) {
        continue;
      }

      this.updateTranscript(segment, isAgent);
    }
  }

  private onDisconnected(): void {

    console.log('Room Disconnected');

    if (this.micTimer) {
      clearTimeout(this.micTimer);
      this.micTimer = null;
    }

    this.audioElements.forEach(audio => {
      audio.pause();
      audio.currentTime = 0;
      audio.srcObject = null;
      audio.remove();
    });

    this.audioElements = [];

    this.localAudioTrack?.stop();
    this.localAudioTrack = undefined;

    this.transcriptMap.clear();
    this.transcripts = [];

    this.connected = false;
    this.connecting = false;
    this.agentSpeaking = false;
    this.manualMuted = false;
    this.muted = false;

    // this.avatarImage = this.idleAvatar;

    this.agentSpeaking = false;
    this.updateAvatar();

    this.cdr.detectChanges();
  }

  private updateTranscript(
    segment: TranscriptionSegment,
    isAgent: boolean
  ): void {

    const text = segment.text?.trim();

    if (!text) {
      return;
    }

    const existing = this.transcriptMap.get(segment.id);

    if (existing) {

      existing.text = text;
      existing.final = segment.final;
      existing.language = segment.language;
      existing.startTime = segment.startTime;
      existing.endTime = segment.endTime;

    } else {

      const transcript: Transcript = {
        id: segment.id,
        text,
        isAgent,
        final: segment.final,
        language: segment.language,
        startTime: segment.startTime,
        endTime: segment.endTime
      };

      this.transcriptMap.set(segment.id, transcript);

      // Keep insertion order
      this.transcripts.push(transcript);
    }

    this.transcripts = [...this.transcripts];

    this.cdr.detectChanges();
    this.scrollToBottom();
  }

  private async enableMic(enable: boolean): Promise<void> {
    if (!this.room || this.micOperation) {
      return;
    }

    this.micOperation = true;

    try {
      const publication = this.room.localParticipant.getTrackPublication(
        Track.Source.Microphone
      ) as LocalTrackPublication | undefined;

      if (enable) {

        // Remove old microphone
        if (publication?.track) {
          await this.room.localParticipant.unpublishTrack(publication.track);
          publication.track.stop();
        }

        // Create new microphone with browser noise suppression
        const audioTrack: LocalAudioTrack = await createLocalAudioTrack({
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        });

        await this.room.localParticipant.publishTrack(audioTrack);

        this.localAudioTrack = audioTrack;
        this.muted = false;

      } else {

        if (publication?.track) {
          await this.room.localParticipant.unpublishTrack(publication.track);
          publication.track.stop();
        }

        this.localAudioTrack = undefined;
        this.muted = true;
      }

    } catch (error) {
      console.error('Failed to toggle microphone:', error);
    } finally {
      this.micOperation = false;
      this.cdr.markForCheck();
    }
  }

  async sendMessage(): Promise<void> {

    const message = this.typedMessage.trim();

    if (!message) {
      return;
    }

    if (
      !this.room ||
      this.room.state !== ConnectionState.Connected
    ) {
      console.error('Room is not connected.');
      return;
    }

    try {

      // Clear input first
      this.typedMessage = '';
      this.cdr.detectChanges();

      // Show user message immediately
      const transcript: Transcript = {
        id: `chat-${Date.now()}`,
        text: message,
        isAgent: false,
        final: true,
        language: 'en',
        startTime: Date.now(),
        endTime: Date.now()
      };

      this.transcripts.push(transcript);
      this.scrollToBottom();

      // Send message to Agent
      await this.room.localParticipant.sendText(message, {
        topic: 'lk.chat'
      });

    } catch (err) {

      console.error('Failed to send message:', err);

      // Restore text if send fails
      this.typedMessage = message;
      this.transcripts.pop();

      this.cdr.detectChanges();
    }
  }

  async toggleAudioMute(): Promise<void> {
    if (!this.room || this.room.state !== ConnectionState.Connected) {
      return;
    }

    this.manualAudioMuted = !this.manualAudioMuted;

    this.audioElements.forEach((audio: HTMLAudioElement) => {
      audio.muted = this.manualAudioMuted;
    });

    console.log(
      this.manualAudioMuted
        ? 'Agent speaker muted'
        : 'Agent speaker unmuted'
    );

    this.cdr.markForCheck();
  }

  async toggleMute(): Promise<void> {
    if (!this.room || this.room.state !== ConnectionState.Connected) {
      return;
    }

    try {
      // Toggle mute state
      this.manualMuted = !this.manualMuted;

      // Enable mic only if not manually muted and agent is not speaking
      await this.enableMic(!(this.manualMuted || this.agentSpeaking));

      console.log('Microphone Muted:', this.manualMuted);
    } catch (error) {
      console.error('Failed to toggle microphone:', error);

      // Revert UI state if operation fails
      this.manualMuted = !this.manualMuted;
    }
  }

  trackTranscript(index: number, item: Transcript): string {
    return item.id;
  }

  async disconnect(): Promise<void> {

    if (!this.room) {
      return;
    }

    try {

      // Cancel pending timer
      if (this.micTimer) {
        clearTimeout(this.micTimer);
        this.micTimer = null;
      }

      // Stop remote audio
      this.audioElements.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
        audio.srcObject = null;
        audio.remove();
      });

      this.audioElements = [];

      // Disable microphone
      await this.room.localParticipant.setMicrophoneEnabled(false);

      // Remove listeners
      this.room.removeAllListeners();

      // Disconnect room
      await this.room.disconnect();

    } catch (err) {

      console.error('Disconnect failed:', err);

    } finally {

      // this.transcriptMap.clear();
      // this.transcripts = [];

      this.connected = false;
      this.connecting = false;
      this.agentSpeaking = false;
      this.manualMuted = false;
      this.muted = false;

      // this.avatarImage = this.idleAvatar;

      this.agentSpeaking = false;
      this.updateAvatar();

      this.localAudioTrack = undefined;
      this.room = null;

      this.cdr.detectChanges();
    }
  }

  toggleAvatar(): void {
    this.showAvatar = !this.showAvatar;
    this.cdr.detectChanges();
  }

  scrollToBottom(): void {

    setTimeout(() => {

      const container = this.transcriptContainer?.nativeElement;

      if (!container) {
        return;
      }

      container.scroll({
        top: container.scrollHeight,
        behavior: 'smooth'
      });

    }, 50);
  }

  async backToAskQuestion(): Promise<void> {

    try {

      // Disconnect if a room exists
      await this.disconnect();

    } catch (error) {

      console.error('Error while disconnecting:', error);

    } finally {

      this.router.navigate(['/askquestions'], {
        queryParams: {
          state: this.stateCode
        }
      });

    }
  }

  async ngOnDestroy(): Promise<void> {

    try {

      if (this.micTimer) {
        clearTimeout(this.micTimer);
        this.micTimer = null;
      }

      if (this.room) {

        // Disable microphone
        await this.room.localParticipant.setMicrophoneEnabled(false);

        // Remove listeners
        this.room.removeAllListeners();

        // Disconnect
        await this.room.disconnect();
      }

      // Cleanup remote audio elements
      this.audioElements.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
        audio.srcObject = null;
        audio.remove();
      });

      this.audioElements = [];

      // Clear transcript state
      this.transcriptMap.clear();
      this.transcripts = [];

    } catch (error) {

      console.error('Error during destroy:', error);

    } finally {

      this.connected = false;
      this.connecting = false;
      this.agentSpeaking = false;
      this.manualMuted = false;
      this.muted = false;

      // this.avatarImage = this.idleAvatar;

      this.localAudioTrack = undefined;
      this.room = null;

      this.cdr.detectChanges();
    }
  }


  get filteredDocuments(): DocumentItem[] {

    const search = this.documentSearch
      ?.trim()
      .toLowerCase();

    if (!search) {
      return this.documents;
    }

    return this.documents.filter(document =>
      document.name.toLowerCase().includes(search)
    );
  }


  toggleDocumentDropdown(event?: Event): void {

    event?.stopPropagation();

    this.showDocumentDropdown =
      !this.showDocumentDropdown;
  }


  selectDocument(document: any): void {

    const index = this.documents.findIndex(
      item => item.message_id === document.message_id
    );

    if (index === -1) {
      return;
    }

    this.currentDocumentIndex = index;

    this.selectedDocument =
      this.documents[index];

    this.showDocumentDropdown = false;
  }


  previousDocument(): void {

    if (this.currentDocumentIndex <= 0) {
      return;
    }

    this.currentDocumentIndex--;

    this.selectedDocument =
      this.documents[this.currentDocumentIndex];
  }


  nextDocument(): void {

    if (
      this.currentDocumentIndex >=
      this.documents.length - 1
    ) {
      return;
    }

    this.currentDocumentIndex++;

    this.selectedDocument =
      this.documents[this.currentDocumentIndex];
  }


  closeDocumentPreview(): void {

    this.selectedDocument = null;

    this.currentDocumentIndex = 0;
  }

}
